import { CommonModule, ViewportScroller} from '@angular/common';
import {
  AfterContentInit, Component, EventEmitter, Input, NO_ERRORS_SCHEMA,
  OnDestroy, OnInit, Output, input, output, inject
} from '@angular/core';
import { FormBuilder, FormGroup, FormsModule, ReactiveFormsModule, Validators } from '@angular/forms';
import { FontAwesomeModule } from '@fortawesome/angular-fontawesome';
import { ButtonsModule } from '@progress/kendo-angular-buttons';
import { DropDownsModule } from '@progress/kendo-angular-dropdowns';
import { InputsModule } from '@progress/kendo-angular-inputs';
import { LabelModule } from '@progress/kendo-angular-label';
import { Role, User } from '../../models/models.lib';
import { FormModes, PHONE_REGEX_V2 } from '../../common/constants.lib';
import { Subscription } from 'rxjs';
import { LoggerService } from '../../shared/logger.service';
import { AutoFocusDirective } from '../../directives/auto-focus.directive';
import { firstOrLastName2RequiredValidator, firstOrLastNameRequiredValidator } from '../../directives/casi.validators';
import { UserDataService } from '../user-data.service';

@Component({
  selector: 'casi-edit-user',
  standalone: true,
  imports: [
    CommonModule,
    FormsModule,
    ReactiveFormsModule,
    FontAwesomeModule,
    DropDownsModule,
    LabelModule,
    InputsModule,
    ButtonsModule,
    AutoFocusDirective
  ],
  schemas: [NO_ERRORS_SCHEMA],
  templateUrl: './edit-user.component.html',
  styleUrl: './edit-user.component.scss',
})
export class EditUserComponent implements OnInit, OnDestroy, AfterContentInit {

  //#region Properties

  private _user: User | undefined;

  @Input({ required: true })
  set user(value: User) {
    this._user = value;
    this.form.patchValue(this._user);
  }
  get user(): User | undefined {
    return this._user
  };
  // @Input({ required: true }) user: User = new User();
  // user = input.required<User>()
  @Input({ required: true }) readonly roles: Role[] = [];
  @Input({ required: true }) readonly selectedRoleIds: Role[] = [];
  @Input({ required: true }) readonly mode: FormModes = FormModes.NOTSET;

  // @Output() submitForm: EventEmitter<FormGroup> = new EventEmitter();
  readonly submitForm = output<FormGroup>();
  // @Output() closeForm: EventEmitter<void> = new EventEmitter();
  readonly closeForm = output<void>();

  // readonly userId = input.required<string>();
  // readonly #userService = inject(UserDataService);
  // readonly userResouce = this.#userService.createUserResource(this.userId);


  form: FormGroup;

  public value: number[] = [];

  private _subs: Subscription[] = [];

  constructor(
    private fb: FormBuilder,
    private logger: LoggerService,
    private scroller: ViewportScroller
  ) {
    this.form = this.fb.group(
      {
        id: [null, []],
        email: ['', [Validators.required, Validators.email]],
        first_name: [null],
        last_name: [null],
        phone: [null, [Validators.pattern(PHONE_REGEX_V2)]],
        userRoles: [null, [Validators.required]]
      },
      {
        validators: [
          firstOrLastNameRequiredValidator
        ]
      }
    );
  }

  //#region Form

  get f() {
    return this.form.controls;
  }
  get email() {
    return this.form.get('email');
  }
  get first_name() {
    return this.form.get('first_name');
  }
  get last_name() {
    return this.form.get('last_name');
  }
  get phone() {
    return this.form.get('phone');
  }
  get userRoles() {
    return this.form.get('userRoles');
  }

  //#endregion

  //#endregion

  //#region Ng Events

  ngOnInit(): void {
    this.logger.debug('ngOnInit...', this.roles, this.selectedRoleIds, this.user);
    this.email?.valueChanges.subscribe(value => {
      if (value && value !== value.toLowerCase()) {
        this.email?.setValue(value.toLowerCase(), { emitEvent: false });
      }
    });
  }

  ngOnDestroy(): void {
    this.logger.debug('ngOnInit...');
    this._subs.forEach(s => s.unsubscribe());
  }

  ngAfterContentInit(): void {
    this.logger.debug('ngAfterContentInit...');
    // this.scroller.scrollToPosition([10, 10]);
    setTimeout(() => {
      // document.body.scrollTo({ top: 0, behavior: 'smooth' });
      this.scroller.scrollToPosition([0, 0]);
      // this.pForm.nativeElement.scrollTop();
    }, 50);
  }

  //#endregion

  onSubmit(): void {
    this.logger.debug(`onSubmit...`, this.form.value, this.mode);
    this.submitForm.emit(this.form);
  }

  closeWindow(): void {
    this.logger.debug(`closeWindow...`);
    this.closeForm.emit();
  }

}
